module.exports = __webpack_public_path__ + "img/9791190406086.ff17b142.jpg";